import { Visibility, VisibilityOff } from '@mui/icons-material';
import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import React, { RefObject, useState } from 'react';
import { IMaskInput } from 'react-imask';

type IdentifierMaskInputProps = {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  visible?: boolean;
  unmask?: boolean;
  identifierType: 'SSN' | 'EIN';
};

const IdentifierMaskInput = React.forwardRef<
  HTMLElement,
  IdentifierMaskInputProps
>((props, ref) => {
  const { onChange, identifierType, visible, ...other } = props;

  const maskType = identifierType === 'EIN' ? '00-0000000' : '000-00-0000';

  const hiddenMaskType =
    identifierType === 'EIN' ? 'XX-XXX0000' : 'XXX-XX-0000';

  const mask = {
    mask: visible ? maskType : hiddenMaskType,
    definitions: {
      X: {
        mask: '0',
        displayChar: '•',
      },
    },
    lazy: false,
  };

  return (
    <IMaskInput
      {...other}
      mask={[mask]}
      inputRef={ref as RefObject<HTMLInputElement>}
      onAccept={(value: string) =>
        onChange({ target: { name: props.name, value } })
      }
      overwrite
    />
  );
});

type SecureIdentifierFieldProps = Omit<
  TextFieldProps,
  'inputComponent' | 'InputProps'
> & {
  identifierType: 'SSN' | 'EIN';
  unmask?: boolean;
  defaultVisible?: boolean;
};

export const SecureIdentifierField: React.FC<SecureIdentifierFieldProps> = ({
  identifierType,
  defaultVisible,
  unmask,
  ...props
}) => {
  const [visible, setVisible] = useState(defaultVisible);

  const handleVisibilityChange = () => {
    setVisible(!visible);
  };

  return (
    <TextField
      {...props}
      type={'text'}
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={{
        inputComponent: IdentifierMaskInput as any,
        inputProps: { unmask, identifierType, visible },
        endAdornment: (
          <InputAdornment
            position="end"
            sx={{ cursor: 'pointer' }}
            onClick={handleVisibilityChange}
          >
            {visible ? <VisibilityOff /> : <Visibility />}
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SecureIdentifierField;
